import { TypedApi } from "@tento-core/typed-api";
import { Network as AppNet } from "../@generated/network";

// Sheet-free API client for brand / marketing / anonymous routes.
//
// These routes only call `/api/public/*`, whose route types and revivers live
// entirely in the app-level codegen namespace (AppNet). By importing ONLY AppNet
// — and never `@tento-lona` / `@tento-lona/sheets` — this client keeps anonymous
// pages free of the ~272-module @tento-lona SDK (incl. the 203-module sheet
// engine) that the full `LonaApi` drags in transitively. See lib/api.ts for the
// full client used by the logged-in app.
const REVIVERS = {
  ...(AppNet.REVIVERS as Record<string, unknown>),
} as Parameters<typeof TypedApi.makeWith<AppNet.Routes>>[0];

export const BrandApi = TypedApi.makeWith<AppNet.Routes>(REVIVERS);
